import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent implements OnInit, OnDestroy {
  /**
   * @description
   * Main application layout.
   * This component is used only to make the layout of the elements (sidebar,header,main content).
   * The main router outlet is located here.
   */

  /**
   * * General
   * @darkMode Is dark-mode enabled
   * @displaySettingsPanel Show/hide settings panel
   * @themeOptions App theme options (sidebarPosition: 'top'|'left'|'right')
   * @subscriptions Array of subscriptions
   */
  darkMode = false;
  displaySettingsPanel = false;
  themeOptions: {
    sidebarPosition: string;
  };
  subscriptions: Subscription[] = [];

  /* ====================================
  *              LIFECYCLES
  ======================================= */

  ngOnInit(): void {
    /**
     * Check and set theme options and darkMode
     */
    const currentState = JSON.parse(localStorage.getItem('darkMode') || '{}');
    this.darkMode = currentState ?? false;
    this.themeOptions = JSON.parse(
      localStorage.getItem('themeOptions') || '{}'
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  /* ====================================
  *             MAIN FEATURES
  ======================================= */

  /**
   * Turn dark mode on/off
   */
  toggleDarkMode() {
    // this.darkMode = !this.darkMode;
    localStorage.setItem('darkMode', JSON.stringify(this.darkMode));
  }

  /**
   * Change sidebar menu postion
   * @param position Set sidebar position 'top', 'left', 'right'
   */
  setSidebarPosition(position: string) {
    this.themeOptions = {
      sidebarPosition: position,
    };
    localStorage.setItem('themeOptions', JSON.stringify(this.themeOptions));
  }
}
